import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme }) => css`
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    border: 1px solid ${theme?.colour?.primary};
    border-radius: 12px;
    padding: 19px;
    padding-bottom: 40px;
    background-color: ${`${theme?.colour?.primary}0D`};
  `}
`;

export default Wrapper(template)